import React, { PropsWithChildren } from "react";
import { useTranslation } from "i18n";
import { useMaintenanceMode } from "shared-services";

import { Spinner } from "../../Atoms/Spinner/Spinner";
import { MaintenancePage } from "../../Molecules/MaintenancePage/MaintenancePage";

export const MaintenanceGate = ({ children }: PropsWithChildren) => {
  const { t, ready } = useTranslation();
  const { isMaintenanceModeActive, isLoading } = useMaintenanceMode();

  if (isLoading || (isMaintenanceModeActive && !ready)) {
    return (
      <div className="flex h-screen w-screen items-center justify-center">
        <Spinner />
      </div>
    );
  }

  if (isMaintenanceModeActive) {
    return (
      <MaintenancePage
        texts={{
          logoLabel: t("common:maintenance.logoLabel"),
          headerText: t("common:maintenance.headerText"),
          messageText: t("common:maintenance.messageText"),
          statusLinkText: t("common:maintenance.statusLinkText"),
        }}
      />
    );
  }

  return <>{children}</>;
};
